module.exports = __webpack_public_path__ + "static/media/0603.30d57f00.png";